import Label from '@/components/UI/Label';
import styles from './Collapse.module.css';
import { JSX, useEffect, useRef, useState } from 'react';
import FaqBtn from '@/components/FAQArea/FaqBtn';

interface Props {
	id: string;
	title: string;
	children: JSX.Element | null;
	collapsed: boolean;
}

const Collapse = (props: Props) => {
	const [collapsed, setCollapse] = useState<boolean>(props.collapsed);
	const [maxHeight, setMaxHeight] = useState<number>(0);
	const contentRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const updateHeight = () => {
			if (contentRef.current) {
				setMaxHeight(contentRef.current.scrollHeight);
			}
		};

		updateHeight();

		// Monitoraggio resize dell'elemento
		if (contentRef.current) {
			const resizeObserver = new ResizeObserver(updateHeight);
			resizeObserver.observe(contentRef.current);

			window.addEventListener('resize', updateHeight);

			return () => {
				window.removeEventListener('resize', updateHeight);
				resizeObserver.disconnect();
			};
		}

		return () => window.removeEventListener('resize', updateHeight);
	}, [collapsed, props.children]);

	const toggleCollapse = () => {
		setCollapse(!collapsed);
	};

	return (
		<div id={props.id} className={styles.mainCollapseContainer}>
			{/* Header sempre visibile */}
			<div className={styles.header} onClick={toggleCollapse}>
				<Label text={props.title} className={styles.headerTitle} />
				<FaqBtn onClick={toggleCollapse} isOpen={collapsed} type="expand" />
			</div>

			{/* Contenitore del contenuto espandibile */}
			<div
				ref={contentRef}
				className={styles.contentContainer}
				aria-hidden={!collapsed}
				style={{ maxHeight: collapsed ? maxHeight : 0 }}
			>
				{props.children}
			</div>
		</div>
	);
};

export default Collapse;
